import React from 'react'
import CakeInquiryForm from '../components/CakeInquiryForm'
import SeoHead from '../components/SeoHead'
import WaveDivider from '../components/WaveDivider'
import { localizeTree } from '../i18n/localizeTree'

export default function ForspoergselPage({ lang = 'da' }) {
  return localizeTree((
    <>
      <SeoHead pageId="cake_inquiry" lang="da" />

      {/* Header Banner */}
      <section className="subpage-hero bg-[#F7ECEE] py-12 sm:py-16 border-b border-[#C68D94]/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-script text-5xl sm:text-6xl text-[#3E3435] font-normal my-3">
            Kage forespørgsel
          </h1>
          <WaveDivider className="text-[#C68D94]/50 mx-auto mb-6" />
          <div className="text-xs sm:text-sm text-[#3E3435]/90 font-light leading-relaxed space-y-2 max-w-xl mx-auto">
            <p>
              Udfyld nedenstående kontaktformular og din henvendelse vil på hverdage blive besvaret indenfor 24 timer.
            </p>
            <p className="italic text-stone-500 text-[11px] sm:text-xs">
              Dine personlige data vil hjælpe os når vi skal kontakte dig. Vi lover at passe på dine data og holde dem sikret.
            </p>
          </div>
        </div>
      </section>

      {/* Form Container */}
      <section className="py-14 sm:py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <CakeInquiryForm />
      </section>
    </>
  ), lang)
}
